// extracted by mini-css-extract-plugin
module.exports = {"messageContentTransform":"MessageContent_messageContentTransform__1wKVH","header":"MessageContent_header__17Zk4","footer":"MessageContent_footer__2FgCN"};